<template>
  <q-dialog
    :model-value="modelValue"
    @update:model-value="$emit('close')"
    @before-hide="$emit('close')"
    position="bottom"
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <q-card class="photographer-booking-card">
      <q-card-section class="flex justify-between">
        <div class="text-h6">
          {{ $t('bookings.bookingWith') }}
          <span class="text-subtitle1">{{ photographerDisplayName }}</span>
        </div>
        <q-btn dense flat icon="close" v-close-popup>
          <q-tooltip class="bg-white text-primary">
            {{ $t('common.close') }}
          </q-tooltip>
        </q-btn>
      </q-card-section>

      <q-card-section class="q-pt-md">
        <div v-if="!photographer" class="q-pa-xl text-center">
          <q-spinner color="primary" size="3em" />
        </div>

        <q-form v-else class="q-gutter-md" @submit.prevent="submitBooking">
          <q-input
            v-model="form.date"
            type="date"
            :label="$t('common.date')"
            dense
            filled
            :rules="[(val) => !!val || 'Required']"
            stack-label
            class="q-mt-sm"
          >
            <template v-slot:prepend>
              <q-icon name="event" />
            </template>
          </q-input>

          <q-input
            v-model.number="form.rate"
            type="number"
            filled
            dense
            :label="$t('bookings.rateLabel')"
            placeholder="0.00"
            step="0.01"
            min="0"
            stack-label
            class="booking-form-field q-mt-sm"
            :rules="[(val) => (val !== null && val !== '') || 'Required']"
          >
            <template #prepend>
              <q-tooltip anchor="top right" self="top middle">
                {{ $t('bookings.currencySupportedLimitations') }}
              </q-tooltip>
              <q-select
                v-model="form.currency"
                :options="['PLN']"
                dense
                borderless
                disable
                filled
                emit-value
                map-options
              />
            </template>
          </q-input>

          <q-input
            v-model="form.message"
            type="textarea"
            dense
            autogrow
            filled
            maxlength="500"
            :label="$t('bookings.detailsMessage')"
            counter
            stack-label
            class="q-mt-sm"
            :rules="[(val) => !!val || 'Required']"
          >
            <template v-slot:prepend>
              <q-icon name="message" />
            </template>
          </q-input>

          <div class="row justify-end q-pt-md">
            <q-btn
              type="submit"
              color="primary"
              unelevated
              :label="$t('bookings.book')"
              :loading="isSubmitting"
              class="bookings-form-button"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'PhotographerBookingForm',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    photographer: {
      type: Object,
      default: null,
    },
  },
  emits: ['close', 'booking-submitted', 'update:modelValue'],
  data() {
    return {
      form: this.getInitialFormState(),
      isSubmitting: false,
    };
  },
  computed: {
    photographerDisplayName() {
      if (!this.photographer) {
        return;
      }
      const p = this.photographer;
      const first = p.firstName?.trim();
      const last = p.lastName?.trim();

      if (first || last) {
        return `${first || ''} ${last || ''}`.trim();
      }

      return p.userName;
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal === true) {
        this.form = this.getInitialFormState();
      }
    },
  },
  methods: {
    getInitialFormState() {
      return {
        date: '',
        message: '',
        currency: 'PLN',
        rate: null,
      };
    },
    async submitBooking() {
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      this.$emit('booking-submitted', this.form);
      this.isSubmitting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep .q-field--dense:not(.q-textarea--autogrow) .q-field__control,
:deep .q-field--dense .q-field__marginal,
:deep .q-field--dense .q-field__before,
:deep .q-field--dense .q-field__prepend {
  height: 50px;
}
.booking-form-field :deep .q-field__control {
  padding: 0 5px;
  background: #f2f2f2;
  background-color: #f2f2f2;
  border-bottom: 2px solid grey;
  &:hover {
    background: transparent;
    background-color: transparent;
  }
}
.photographer-booking-card {
  width: 100%;
  max-width: 600px;
  min-height: 300px;
  @media (min-width: $breakpoint-sm-min) {
    margin: 0 auto;
  }
}
</style>
